import { Provider } from 'react-redux'
import { store } from '../state/store'
import { DarkModeProvider } from './DarkModeProvider'

function AppProvider({ children }) {
  return (
    <DarkModeProvider>
      <Provider store={store}>{children}</Provider>
    </DarkModeProvider>
  )
}

export default AppProvider
